// Small helper to persist and notify sidebar open/close state.
export function setSidebarOpenPersist(val) {
  try {
    localStorage.setItem('sidebar:open', val ? 'true' : 'false');
  } catch (e) {
    // ignore storage errors
  }

  try {
    if (window.setSidebarState) {
      window.setSidebarState(!!val);
    } else {
      // best-effort event notification
      window.dispatchEvent(new Event(val ? 'openSidebar' : 'closeSidebar'));
    }
  } catch (e) {
    // ignore
  }
}

// Convenience for navigation flows: persist desired sidebar state, then navigate.
export function navigateWithSidebar(navigateFn, path, open = true) {
  setSidebarOpenPersist(open);
  navigateFn(path);
}

export default {
  setSidebarOpenPersist,
  navigateWithSidebar,
};
